<template>
  <GfrLayout>
    <GfrLayoutHeader :class="['app-layout-header !h-17 pointer-events-auto', isScrolling && 'opacity-0']">
      <GfrContainer class="flex justify-between">
        <GfrLogo :link="`/${$route.params.lang}/craftland/`" class="app-layout-logo">
          <img class="w-full" src="~@/assets/images/logo.svg" alt="Logo" />
        </GfrLogo>
        <div class="flex items-center flex-1 h-full">
          <ClMenu class="flex-1 ml-5" />
          <CommonSearch v-if="searchStatus" is-game class="scale-[1.2] max-lg:scale-[0.65] lg:ml-5.5 origin-right" />
          <CommonMultiLanguage
            v-if="langList.length > 1"
            class="scale-[1.2] max-lg:scale-[0.65] lg:ml-5.5 origin-right"
            :list="langList"
            :global="globalLang"
            :offset-y="8"
            only-self
          />
        </div>
      </GfrContainer>
    </GfrLayoutHeader>
    <GfrLayoutMain>
      <slot />
    </GfrLayoutMain>
  </GfrLayout>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { LanguageItem } from '../components/common/MultiLanguage/index.vue'
const route = useRoute()
const router = useRouter()
// config data
const { config } = storeToRefs(useStore())
// nav data
const globalLang = computed(() => config.value.lang_list.some((item) => item.region === 'GLOBAL'))
const langList = computed(() => {
  const list = config.value.lang_list
  const newList: LanguageItem[] = []
  list.forEach((item) => {
    newList.push({
      label: item.abbr,
      name: item.lang,
      region: item.region,
      id: item.id,
      default: item.is_default
    })
  })
  return newList
})

const searchStatus = computed(
  () =>
    config.value.footer.search_status &&
    (config.value.footer.search_terms_documents || config.value.footer.search_terms_tutorial)
)
const isScrolling = ref(false)
let timer: any
const throttleScroll = throttle(handleScroll, 30)
function handleScroll() {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  const header = document.querySelector('.app-layout-header')
  isScrolling.value = !!(header && scrollTop > header.clientHeight)
  if (isScrolling.value) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      isScrolling.value = false
    }, 600)
  }
}
onBeforeMount(() => {
  if (inGame() || route.query.layout === 'cl' || session.getItem('layout') === 'cl') {
    session.setItem('layout', 'cl')
    if (route.query.layout === 'cl') {
      router.replace({ query: {} }) // clear query
    }
  } else {
    // session.removeItem('layout')
    navigateTo(route.path.replace('/craftland', ''))
  }
})
onMounted(() => {
  window.addEventListener('scroll', throttleScroll)
})
onUnmounted(() => {
  window.removeEventListener('scroll', throttleScroll)
})
</script>
<style lang="scss">
//html {
//  font-size: calc(100vw / 1536 * 16);
//}
//@media screen and (max-width: 1334px) {
//  html {
//    font-size: calc(100vw / 1334 * 16);
//  }
//}
//@media screen and (min-width: 1536px) {
//  html {
//    font-size: calc(100vw / 1920 * 16);
//  }
//}

@media not all and (min-width: 1024px) {
  .layout-footer-lang {
    display: none;
  }

  .app-footer-logo {
    width: 250px;
    height: 64px;
  }
}
@media screen and (min-width: 1024px) {
  .layout-footer-contact {
    max-width: 25%;
    order: 2;
    margin-top: 1rem;
  }
  .app-footer-logo {
    width: 250px;
    height: 64px;
  }
}
</style>
<style lang="postcss" scoped>
.app-layout-header {
  @apply transition-opacity duration-300 ease-in;
}
.app-layout-logo {
  @apply w-8.5;
}
</style>
